import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import Dashboard from "../views/Dashboard.vue";
import UsersVer from "../views/users/ver.vue";
import productoPublicar from "../views/productos/publicar.vue";
import productosPublicados from "../views/productos_publicados/index.vue";
import Pedidos from "../views/pedidos/index.vue";
import PedidosVer from "../views/pedidos/ver.vue";
import PedidosProduccion from "../views/pedidos/produccion.vue";
import UsersEditar from "../views/users/editar.vue";
import verDocumentos from "../views/verDocumentos.vue";
import Repartidores from "../views/repartidores/index.vue";
import RepartidoresAgregar from "../views/repartidores/agregar.vue";
import RepartidoresVer from "../views/repartidores/ver.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: { guestOnly: true }
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: { authOnly: true }
  },
  {
    path: "/users/ver/:id",
    name: "UsersVer",
    component: UsersVer,
    meta: { authOnly: true }
  },
  {
    path: "/users/editar/:id",
    name: "UsersEditar",
    component: UsersEditar,
    meta: { authOnly: true }
  },
  // Productos
  {
    path: "/productos/publicar/:id",
    name: "productoPublicar",
    component: productoPublicar,
    meta: { authOnly: true }
  },
  {
    path: "/productos_publicados/",
    name: "productosPublicados",
    component: productosPublicados,
    meta: { authOnly: true }
  },
  // Pedidos
  {
    path: "/pedidos/",
    name: "Pedidos",
    component: Pedidos,
    meta: { authOnly: true }
  },
  {
    path: "/pedidos/produccion",
    name: "PedidosProduccion",
    component: PedidosProduccion,
    meta: { authOnly: true }
  },
  {
    path: "/pedidos/ver/:id",
    name: "PedidosVer",
    component: PedidosVer,
    meta: { authOnly: true }
  },
  // Documentos
  {
    path: "/ver-documentos/",
    name: "verDocumentos",
    component: verDocumentos,
    meta: { authOnly: true }
  },
  {
    path: "/repartidores/",
    name: "Repartidores",
    component: Repartidores,
    meta: { authOnly: true }
  },
  {
    path: "/repartidores/agregar",
    name: "RepartidoresAgregar",
    component: RepartidoresAgregar,
    meta: { authOnly: true }
  },
  {
    path: "/repartidores/ver/:id",
    name: "RepartidoresVer",
    component: RepartidoresVer,
    meta: { authOnly: true }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

function isLoggedIn() {
  return localStorage.getItem("token") != null;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.authOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!isLoggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else if (to.matched.some(record => record.meta.guestOnly)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (isLoggedIn()) {
      next({
        path: "/dashboard",
        query: { redirect: to.fullPath }
      });
    } else {
      next();
    }
  } else {
    next(); // make sure to always call next()!
  }
});

export default router;
